import { createFileRoute, notFound } from "@tanstack/react-router";
import { EmbedWidget } from "@/components/prayer/EmbedWidget";
import { findKotaBySlug, getProvinsi } from "@/data/locations";

export const Route = createFileRoute("/embed/jadwal-sholat/$kota/")({
  loader: ({ params }) => {
    const loc = findKotaBySlug(params.kota) ?? getProvinsi(params.kota);
    if (!loc) throw notFound();
    return { loc };
  },
  head: () => ({ meta: [{ name: "robots", content: "noindex" }] }),
  component: () => {
    const { loc } = Route.useLoaderData();
    return <EmbedWidget variant="sholat" location={loc} />;
  },
});
